import orderConstants from './constants'
import printJS from 'print-js';

export const setOrderId = (data) => { 
  return {
    type: orderConstants.SET_ORDER_ID,
    payload: data,
  }
}
export const getOrderDetails = (payload, callback) => { 
  return {
    type: orderConstants.LOAD_ORDER_DETAILS,
    payload,
    callback
  }
}

export const setOrderInfor = (data) => { 
  return {
    type: orderConstants.SET_ORDER_INFOR,
    payload: data,
  }
}

export const setUsersChecked = (data) => { 
  return {
    type: orderConstants.SET_USERS_CHECKED,
    payload: data,
  }
}

export const loadCustomers = (data, onSuccess) => { 
  return {
    type: orderConstants.LOAD_CUSTOMERS,
    payload: data,
    onSuccess
  }
}

export const setCustomers = (data) => { 
  return {
    type: orderConstants.SET_CUSTOMERS,
    payload: data,
  }
}

export const loadCustomer = (data, callback) => { 
  return {
    type: orderConstants.LOAD_CUSTOMER_INFO,
    payload: data,
    callback
  }
}

export const setCustomer = (data) => { 
  return {
    type: orderConstants.SET_CUSTOMER_INFO,
    payload: data,
  }
}

export const loadThuocs = (data, callback) => { 
  return {
    type: orderConstants.LOAD_THUOCS,
    payload: data,
    onSuccess: callback
  }
}

export const setThuocs = (data) => { 
  return {
    type: orderConstants.SET_THUOCS,
    payload: data,
  }
}

export const loadKhos = (data, onSuccess) => { 
  return {
    type: orderConstants.LOAD_KHOS,
    payload: data,
    onSuccess
  }
}

export const setKhos = (data) => { 
  return {
    type: orderConstants.SET_KHOS,
    payload: data,
  }
}

export const loadUsers = (data, callback) => { 
  return {
    type: orderConstants.LOAD_USERS,
    payload: data,
    onSuccess: callback
  }
}

export const setUsers = (data) => { 
  return {
    type: orderConstants.SET_USERS,
    payload: data || [],
  }
}

export const loadThuoc = (data, onSuccess) => { 
  return {
    type: orderConstants.LOAD_THUOC_INFO,
    payload: data,
    onSuccess
  }
}

export const setThuoc = (data) => { 
  return {
    type: orderConstants.SET_THUOC_INFO,
    payload: data || {},
  }
}

export const unlockOrder = (payload, callback) => {
  return {
    type: orderConstants.UNLOCK_ORDER,
    payload,
    callback
  }
}

export const setMode = (mode) => {
  return {
    type: orderConstants.SET_MODE_FORM,
    payload: mode
  }
}

export const setItems = (items) => {
  return {
    type: orderConstants.SET_ITEMS,
    payload: items,
  }
}

export const setItem = (item) => {
  return {
    type: orderConstants.SET_ITEM,
    payload: item,
  }
}

export const setWarning = (err) => {
  return {
    type: orderConstants.SET_WARNING_ITEM,
    payload: err,
  }
}

export const setError = (err) => {
  return {
    type: orderConstants.SET_ERROR,
    payload: err,
  }
}

export const setMessage = (message) => {
  return {
    type: orderConstants.SET_MESSAGE,
    payload: message,
  }
}

export const setIsLoading = (isLoading) => {
  return {
    type: orderConstants.SET_IS_LOADING,
    payload: isLoading,
  }
}

export const setFlagAddItem = (flag) => {
  return {
    type: orderConstants.SET_FLAG_ADD_ITEM,
    payload: flag,
  }
}

export const saveOrder = (callback) => {
  return {
    type: orderConstants.SAVE_ORDER,
    callback,
  }
}

export const setTypeOrder = (data) => {
  return {
    type: orderConstants.SET_TYPEOF_ORDER,
    payload: data,
  }
}

export const resetForm = () => {
  return {
    type: orderConstants.RESET_FORM,
  }
}

export const setCallbackFunc = (callback) => {
  return {
    type: orderConstants.SET_CALLBACK_FUNC,
    payload: callback
  }
}

export const deleteOrder = (formData, onSuccess) => {
  return {
    type: orderConstants.DELETE_ORDER,
    payload: formData,
    onSuccess
  }
}

export const cancelOrder = (formData, onSuccess) => {
  return {
    type: orderConstants.CANCEL_ORDER,
    payload: formData,
    onSuccess
  }
}

export const approveOrder = (formData, onSuccess) => {
  return {
    type: orderConstants.APPROVE_ORDER,
    payload: formData,
    onSuccess
  }
}

export const processOrder = (formData, onSuccess) => {
  return {
    type: orderConstants.PROCESS_ORDER,
    payload: formData,
    onSuccess
  }
}

export const returnOrder = (formData) => {
  return {
    type: orderConstants.RETURN_ORDER,
    payload: formData
  }
}

export const revertOrder = (formData) => {
  return {
    type: orderConstants.REVERT_ORDER,
    payload: formData
  }
}

export const loadOrderHistory = (data) => { 
  return {
    type: orderConstants.LOAD_ORDER_HISTORY,
    payload: data,
  }
}

export const SetOrderHistory = (data) => { 
  return {
    type: orderConstants.SET_ORDER_HISTORY,
    payload: data || {},
  }
}

export const loadOrderExport = (data) => { 
  return {
    type: orderConstants.LOAD_ORDER_EXPORT,
    payload: data,
  }
}

export const loadOrderExcel = (requestData, onSuccess) => { 
  return {
    type: orderConstants.LOAD_ORDER_EXCEL,
    payload: requestData,
    onSuccess
  }
}

export const calcOrder = (onSuccess) => { 
  return {
    type: orderConstants.CALC_ORDER,
    onSuccess,
  }
}

export const canPushOrder = (formData, onSuccess) => { 
  return {
    type: orderConstants.CAN_PUSH_ORDER,
    payload: formData,
    onSuccess,
  }
}

export const SetOrderExport = (data) => { 
  const pdfFile = new Blob([data], {
    type: "application/pdf;charset=UTF-8"
  });
  const pdfUrl = URL.createObjectURL(pdfFile);
  printJS(pdfUrl);
  return {
    type: orderConstants.SET_ORDER_EXPORT,
    payload: data || {},
  }
}

export const SetOrderConfirmMoney = (data, onSuccess) => { 
  return {
    type: orderConstants.SET_ORDER_CONFIRM_MONEY,
    payload: data || {},
    onSuccess
  }
}


// WEBPACK FOOTER //
// ./src/views/Order/actions.js